// simple function to convert snake_case to camelCase
export const camelizeKeys = (obj: any) => {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase()),
        value
      ])
    );
  };
  